import { createFileRoute } from "@tanstack/react-router";

import AddAccount5 from "@/features/onboarding/AddAccount5";
import BasicLayout from "@/layouts/Basic";

export const Route = createFileRoute("/_auth-basic/add-account-5")({
  component: () => (
    <BasicLayout>
      <AddAccount5 />
    </BasicLayout>
  ),
});
